

import Vue from 'vue'
import App from './App'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import Sticky from 'vux/src/components/sticky/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ViewBox from 'vux/src/components/view-box/index.vue'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'


Vue.component('Sticky', Sticky)
Vue.component('Tab', Tab)
Vue.component('TabItem', TabItem)
Vue.component('ViewBox', ViewBox)
Vue.component('XDialog', XDialog)

Vue.use(AjaxPlugin)
Vue.use(AlertPlugin)
Vue.use(WechatPlugin)
Vue.use(ToastPlugin)

Vue.config.productionTip = false




















/* eslint-disable no-new */
new Vue({
el: '#app',
template: '<App/>',
components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js